import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { notification } from "antd";
import {
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TobNavBar from "../../DashBaord/Top_navbar";
import moment from "moment";
import { checkWinner, createVoucher, checkHourlyWinner } from "../../../controllers/V1/winnersControllers";
import Loading from "../../../components/Loading/LoadingEffect";
import { useNavigate } from "react-router-dom";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};


export default function BasicTabs() {
  const targetRef = useRef(null);
  const USER_DATA = JSON.parse(sessionStorage?.getItem('ADMIN-INFO'));
  const navigate = useNavigate();
  const [orderId, setOrderId] = useState("UWINN");
  const [isLoading, setIsLoading] = useState(false);
  const [winnerData, setWinnerList] = useState([]);
  const [game_type, setGameType] = useState("lotto");
  // const [orderData, setOrderData] = useState({});
  const [ADDEDITDATA, setAddEditData] = useState({
    prepared_by : USER_DATA?.account_id || "N/A",
    date : moment().format('YYYY-MM-DD'),
    document_type : "Emirates ID",
  });

  const handleGenerate = async (e) => {
    e.preventDefault(0);
    setIsLoading(true);
    try {
      let error = '';
      const formData = new FormData(e.target);
      if(!formData?.get('payment_to')){
        error = "Payment to is required."
      } else if(!formData?.get('date')){
        error = "Date is required."
      } else if(!formData?.get('seller_name')){
        error = "Seller name is required."
      } else if(!formData?.get('document_type')){
        error = "Document type is required."
      } else if(!formData?.get('document_no')){
        error = "Document no is required."
      } else if(!ADDEDITDATA?.purchase_date){
        error = "Purchase date is required."
      } else if(!ADDEDITDATA?.order_id){
        error = "Order id is required."
      } else if(!formData?.get('game_name')){
        error = "Game name is required."
      } else if(!formData?.get('contact_no')){
        error = "Contact number is required."
      } else if(!formData?.get('payment_to')){
        error = "Received by is required."
      } else if(!ADDEDITDATA?.prepared_by){
        error = "Prepared by is required."
      }

      if(error === ''){
        // Append fields from state that are not in the form
        formData.append('purchase_date', moment(ADDEDITDATA?.purchase_date).format('YYYY-MM-DD') || "");
        // formData.append('draw_date', moment(ADDEDITDATA?.draw_date).format('YYYY-MM-DD') || "");
        formData.append('order_id', ADDEDITDATA?.order_id || "");
        formData.append('received_by', formData?.get('payment_to') || "");
        formData.append('prepared_by', ADDEDITDATA?.prepared_by || "");
        formData.append('total_amount', ADDEDITDATA?.total_amount || 0);
        formData.append('winnerList', JSON.stringify(winnerData || []));

        
        const res = await createVoucher(formData);
        if(res?.status === true){
          navigate('/winners/voucher-pdf', {state : res?.result})
        } else{
          notification.open({
            message: "Oops!",
            description: res.message || `Please try again.`,
            placement: "topRight",
            icon: (
              <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />
            ),
            duration: 2,
          });
        }
      } else{
        notification.open({
          message: "Oops!",
          description: error || `Please enter the required fields.`,
          placement: "topRight",
          icon: (
            <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />
          ),
          duration: 2,
        });
      }
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };


  const fetchWinnerDetails = async () => {
    try {
      if (!orderId || orderId === "UWINN") {
        notification.open({
          message: "Oops!",
          description: `Please enter a valid order id.`,
          placement: "topRight",
          icon: (
            <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />
          ),
          duration: 2,
        });
        return;
      } else {
        setIsLoading(true);
        const options = {
          order_id: orderId,
        };
        let res = {};
        if(game_type === "hourly"){
          res = await checkHourlyWinner(options);
        } else{
          res = await checkWinner(options);
        }
        
        if (res.status === true) {
          const { orderData, winnerList } = res?.result;
          if (!orderData || !winnerList || winnerList?.length === 0) {
            notification.open({
              message: "Oops!",
              description: `Invalid Order ID.`,
              placement: "topRight",
              icon: (
                <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />
              ),
              duration: 2,
            });
            
          } else if (!winnerList || winnerList?.length === 0) {
            notification.open({
              message: "Oops!",
              description: `Prize not paid.`,
              placement: "topRight",
              icon: (
                <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />
              ),
              duration: 2,
            });
          } else {
            setWinnerList(winnerList);
            if(game_type === "hourly"){
              let dd = await prepareHourlyData(winnerList, orderData);
            } else{
              let redds = await prepareLottoData(winnerList, orderData);
            }
          }
        } else {
          notification.open({
            message: "Oops!",
            description: res?.message || "Something went wrong, please try again.",
            placement: "topRight",
            icon: (
              <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />
            ),
            duration: 2,
          });
          
        }
      }
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const prepareLottoData = async (winnerList, orderData) => {
    try {
      const totalAmount = winnerList
        ?.map((item) => parseFloat(item?.amount * parseFloat(item?.qty)) || 0)
        .reduce((acc, curr) => acc + curr, 0);
      setAddEditData({
        ...(orderData?.user_type === "Users" ? {
          payment_to: `${orderData?.user_oid?.users_name} ${orderData?.user_oid?.last_name}`,
          received_by: `${orderData?.user_oid?.users_name} ${orderData?.user_oid?.last_name}`,
          contact_no: orderData?.user_oid?.users_mobile,
        } : {
          payment_to: '',
          received_by: '',
          contact_no: '',
        }),
        area: orderData?.user_oid?.area || "",
        voucher_no: "",
        date: moment().format("YYYY-MM-DD"),
        ...(orderData?.user_type !== "Users" ? {
          seller_name: `${orderData?.user_oid?.users_name} ${orderData?.user_oid?.last_name}`,
        } : {
          seller_name: '',
        }),
        document_type: "Emirates ID",
        document_no: "",
        purchase_date: moment(orderData?.created_at).format("YYYY-MM-DD"),
        draw_date : moment(orderData?.draw_date).format("YYYY-MM-DD"),
        order_id: orderId,
        game_name: orderData?.product_title || "",

        prepared_by : USER_DATA?.account_id || "N/A",
        checked_by: "",
        authorized_by: "",
        total_amount: totalAmount,
      });
      return true;
    } catch (error) {
      
    }
  }

  const prepareHourlyData = async (winnerList, orderData) => {
    try {
      const totalAmount = winnerList
        ?.map((item) => parseFloat(item?.amount * parseFloat(item?.qty)) || 0)
        .reduce((acc, curr) => acc + curr, 0);
      setAddEditData({
        ...(orderData?.user_type === "Users" ? {
          payment_to: `${orderData?.users_oid?.users_name} ${orderData?.users_oid?.last_name}`,
          received_by: `${orderData?.users_oid?.users_name} ${orderData?.users_oid?.last_name}`,
          contact_no: orderData?.users_oid?.users_mobile,
        } : {
          payment_to: '',
          received_by: '',
          contact_no: '',
        }),
        voucher_no: "",
        date: moment().format("YYYY-MM-DD"),
        ...(orderData?.user_type !== "Users" ? {
          seller_name: `${orderData?.users_oid?.users_name} ${orderData?.users_oid?.last_name}`,
        } : {
          seller_name: '',
        }),
        document_type: "Emirates ID",
        document_no: "",
        purchase_date: moment(orderData?.created_at * 1000).format("YYYY-MM-DD"),
        draw_date : moment(orderData?.draw_time * 1000).format("YYYY-MM-DD"),
        order_id: orderData?.order_id,
        game_name: orderData?.products_name || "",

        prepared_by : USER_DATA?.account_id || "N/A",
        checked_by: "",
        authorized_by: "",
        total_amount: totalAmount,
      });
      return true;
    } catch (error) {
      
    }
  }

  const handleChange = (e) => {
    try {
      const { name, value } = e.target;
      setAddEditData((pre) => ({
        ...pre,
        [name]: value,
      }));
    } catch (error) {}
  };

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Generate Voucher"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <VendorList>
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="container-fluid">
                        <div className="categories_open_popup_main_contnet mt-4">
                          <div className="form-group row">
                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                              {/* <input
                                style={{ textTransform: "uppercase" }}
                                type="text"
                                name="order_id"
                                id="order_id"
                                value={orderId}
                                onChange={(e) => setOrderId(e.target.value)}
                                placeholder="Enter order id"
                                class="form-control categories_select_tg_enter_product"
                              /> */}
                              <select name="game_type" id="game_type" class="form-control categories_select_tg_enter_product" onChange={(e)=>setGameType(e.target.value)} >
                                <option value={"lotto"} selected>Lotto Games</option>
                                <option value={"hourly"}>Hourly Games</option>
                              </select>
                            </div>

                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <input
                                style={{ textTransform: "uppercase" }}
                                type="text"
                                name="order_id"
                                id="order_id"
                                value={orderId}
                                onChange={(e) => setOrderId(e.target.value)}
                                placeholder="Enter order id"
                                class="form-control categories_select_tg_enter_product"
                              />
                              <span style={{ color: "blue", fontSize: "14px" }}>
                                *Note : Enter Lotto Order ID.
                              </span>
                            </div>

                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                              <button
                                type="button"
                                className="btn btn-light categories_cancel_button"
                                onClick={fetchWinnerDetails}
                              >
                                {" "}
                                Search{" "}
                              </button>
                            </div>
                          </div>
                          <hr />
                          <form onSubmit={handleGenerate}>
                            <div className="form-group row">
                              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label
                                  for="payment_to"
                                  className="all_lable_for_vendor_dashbaord"
                                >
                                  <span style={{ color: "red" }}>*</span>
                                  Payment To :{" "}
                                </label>
                                <input
                                  type="text"
                                  name="payment_to"
                                  id="payment_to"
                                  value={ADDEDITDATA?.payment_to}
                                  onChange={handleChange}
                                  placeholder="Enter payment to "
                                  class="form-control categories_select_tg_enter_product capitalize"
                                />
                              </div>

                              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label
                                  for="date"
                                  className="all_lable_for_vendor_dashbaord"
                                >
                                  <span style={{ color: "red" }}>*</span>
                                  Date :
                                </label>
                                <input
                                  type="date"
                                  name="date"
                                  id="date"
                                  value={ADDEDITDATA?.date}
                                  onChange={handleChange}
                                  class="form-control categories_select_tg_enter_product"
                                />
                              </div>

                              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label
                                  for="contact_no"
                                  className="all_lable_for_vendor_dashbaord"
                                >
                                  <span style={{ color: "red" }}>*</span>
                                  Contact No. :{" "}
                                </label>
                                <input
                                  type="number"
                                  name="contact_no"
                                  id="contact_no"
                                  value={ADDEDITDATA?.contact_no}
                                  onChange={handleChange}
                                  placeholder="Enter contact number"
                                  class="form-control categories_select_tg_enter_product"
                                />
                              </div>

                              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label
                                  for="seller_name"
                                  className="all_lable_for_vendor_dashbaord"
                                >
                                  <span style={{ color: "red" }}>*</span>
                                  Seller Name :{" "}
                                </label>
                                <input
                                  type="text"
                                  name="seller_name"
                                  id="seller_name"
                                  value={ADDEDITDATA?.seller_name}
                                  onChange={handleChange}
                                  placeholder="Enter bind person name"
                                  class="form-control categories_select_tg_enter_product"
                                />
                              </div>

                              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label
                                  for="draw_date"
                                  className="all_lable_for_vendor_dashbaord"
                                >
                                  Draw Date :{" "}
                                </label>
                                <input
                                  type="date"
                                  name="draw_date"
                                  id="draw_date"
                                  value={ADDEDITDATA?.draw_date}
                                  onChange={handleChange}
                                  class="form-control categories_select_tg_enter_product"
                                />
                              </div>

                              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label
                                  for="purchase_date"
                                  className="all_lable_for_vendor_dashbaord"
                                >
                                  <span style={{ color: "red" }}>*</span>
                                  Purchase Date :{" "}
                                </label>
                                <input
                                  type="date"
                                  name="purchase_date"
                                  id="purchase_date"
                                  value={ADDEDITDATA?.purchase_date}
                                  // onChange={handleChange}
                                  disabled
                                  class="form-control categories_select_tg_enter_product"
                                />
                              </div>

                              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label
                                  for="order_id"
                                  className="all_lable_for_vendor_dashbaord"
                                >
                                  <span style={{ color: "red" }}>*</span>
                                  Ticket ID :{" "}
                                </label>
                                <input
                                  type="text"
                                  name="order_id"
                                  id="order_id"
                                  value={ADDEDITDATA?.order_id}
                                  disabled
                                  placeholder="Enter ticket id"
                                  class="form-control categories_select_tg_enter_product"
                                />
                              </div>

                              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label
                                  for="game_name"
                                  className="all_lable_for_vendor_dashbaord"
                                >
                                  <span style={{ color: "red" }}>*</span>
                                  Game Name :{" "}
                                </label>
                                <input
                                  type="text"
                                  name="game_name"
                                  id="game_name"
                                  value={ADDEDITDATA?.game_name}
                                  onChange={handleChange}
                                  placeholder="Enter game name"
                                  class="form-control categories_select_tg_enter_product"
                                />
                              </div>

                              

                              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label
                                  for="received_by"
                                  className="all_lable_for_vendor_dashbaord"
                                >
                                  <span style={{ color: "red" }}>*</span>
                                  Received By :{" "}
                                </label>
                                <input
                                  type="text"
                                  name="received_by"
                                  id="received_by"
                                  value={ADDEDITDATA?.payment_to}
                                  // onChange={handleChange}
                                  disabled
                                  placeholder="Enter received by"
                                  class="form-control categories_select_tg_enter_product capitalize"
                                />
                              </div>

                              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label
                                  for="prepared_by"
                                  className="all_lable_for_vendor_dashbaord"
                                >
                                  <span style={{ color: "red" }}>*</span>
                                  Prepared By :{" "}
                                </label>
                                <input
                                  type="text"
                                  name="prepared_by"
                                  id="prepared_by"
                                  // onChange={handleChange}
                                  value={ADDEDITDATA?.prepared_by}
                                  disabled
                                  placeholder="Enter prepared by"
                                  class="form-control categories_select_tg_enter_product"
                                />
                              </div>

                              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label
                                  for="checked_by"
                                  className="all_lable_for_vendor_dashbaord"
                                  value={ADDEDITDATA?.checked_by}
                                >
                                  {" "}
                                  Checked By :{" "}
                                </label>
                                <input
                                  type="text"
                                  name="checked_by"
                                  id="checked_by"
                                  placeholder="Enter checked by"
                                  onChange={handleChange}
                                  class="form-control categories_select_tg_enter_product"
                                />
                              </div>

                              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label
                                  for="authorized_by"
                                  className="all_lable_for_vendor_dashbaord"
                                >
                                  {" "}
                                  Authorized By :{" "}
                                </label>
                                <input
                                  type="text"
                                  name="authorized_by"
                                  id="authorized_by"
                                  value={ADDEDITDATA?.authorized_by}
                                  onChange={handleChange}
                                  placeholder="Enter authorized by"
                                  class="form-control categories_select_tg_enter_product"
                                />
                              </div>

                              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label
                                  for="area"
                                  className="all_lable_for_vendor_dashbaord"
                                >
                                  Area :
                                </label>
                                <input
                                  type="text"
                                  name="area"
                                  id="area"
                                  value={ADDEDITDATA?.area}
                                  onChange={handleChange}
                                  placeholder="Enter area"
                                  class="form-control categories_select_tg_enter_product"
                                />
                              </div>

                              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label
                                  for="document_type"
                                  className="all_lable_for_vendor_dashbaord"
                                >
                                  <span style={{ color: "red" }}>*</span>
                                  Document Type :{" "}
                                </label>
                                <select
                                  name="document_type"
                                  id="document_type"
                                  className="form-control categories_select_tg_enter_product"
                                  onChange={handleChange}
                                >
                                  <option value={""} selected disabled>
                                    Select document
                                  </option>
                                  <option
                                    value={"Emirates ID"}
                                    selected={
                                      ADDEDITDATA?.document_type ===
                                      "Emirates ID"
                                    }
                                  >
                                    Emirates ID
                                  </option>
                                  <option
                                    value={"Passport"}
                                    select={
                                      ADDEDITDATA?.document_type === "Passport"
                                    }
                                  >
                                    Passport
                                  </option>
                                </select>
                              </div>

                              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label
                                  for="document_no"
                                  className="all_lable_for_vendor_dashbaord"
                                >
                                  <span style={{ color: "red" }}>*</span>
                                  Document No. :{" "}
                                </label>
                                <input
                                  type="text"
                                  name="document_no"
                                  id="document_no"
                                  value={ADDEDITDATA?.document_no}
                                  onChange={handleChange}
                                  placeholder="Enter document number"
                                  class="form-control categories_select_tg_enter_product"
                                />
                              </div>

                              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label
                                  for="doc"
                                  className="all_lable_for_vendor_dashbaord"
                                >
                                  Document :
                                </label>
                                <input
                                  type="file"
                                  name="doc"
                                  id="doc"
                                  accept="image/*"
                                  class="form-control categories_select_tg_enter_product"
                                />
                              </div>

                              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label
                                  for="order_slip"
                                  className="all_lable_for_vendor_dashbaord"
                                >
                                  Order Slip :
                                </label>
                                <input
                                  type="file"
                                  name="order_slip"
                                  id="order_slip"
                                  accept="image/*"
                                  class="form-control categories_select_tg_enter_product"
                                />
                              </div>

                              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label
                                  for="redeem_slip"
                                  className="all_lable_for_vendor_dashbaord"
                                >
                                  Redeem Slip :
                                </label>
                                <input
                                  type="file"
                                  name="redeem_slip"
                                  id="redeem_slip"
                                  accept="image/*"
                                  class="form-control categories_select_tg_enter_product"
                                />
                              </div>

                              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label
                                  for="other_attachment"
                                  className="all_lable_for_vendor_dashbaord"
                                >
                                  Other Attachment :
                                </label>
                                <input
                                  type="file"
                                  name="other_attachment"
                                  id="other_attachment"
                                  accept="image/*"
                                  class="form-control categories_select_tg_enter_product"
                                />
                              </div> 

                              {winnerData && winnerData?.length > 0 && (
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                  <hr />
                                  <table
                                    className="table table-bordered"
                                    id="dataTable"
                                    width="100%"
                                    cellspacing="0"
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          style={{
                                            backgroundColor: "#136bb963",
                                          }}
                                        >
                                          Sl. No.
                                        </th>
                                        <th
                                          style={{
                                            backgroundColor: "#136bb963",
                                          }}
                                        >
                                          Description
                                        </th>
                                        <th
                                          style={{
                                            backgroundColor: "#136bb963",
                                          }}
                                        >
                                          No. of winning
                                        </th>
                                        <th
                                          style={{
                                            backgroundColor: "#136bb963",
                                          }}
                                        >
                                          Amount
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {winnerData.map((items, index) => (
                                        <tr>
                                          <td>{index + 1}</td>
                                          <td>
                                            Winning Amount {`${items.amount}`}
                                          </td>
                                          <td>{items.qty}</td>
                                          <td>{`AED ${parseFloat(
                                            items?.total
                                          )?.toFixed(2)}`}</td>
                                        </tr>
                                      ))}
                                      <tr>
                                        <td
                                          colSpan="3"
                                          style={{
                                            textAlign: "left",
                                            backgroundColor: "#136bb963",
                                          }}
                                        >
                                          Total Amount
                                        </td>
                                        <td
                                          style={{
                                            backgroundColor: "#136bb963",
                                          }}
                                        >
                                          AED{" "}
                                          {ADDEDITDATA?.total_amount?.toFixed(
                                            2
                                          ) || 0}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              )}

                              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div className="inventory_open_popup_action_btn">
                                  <button
                                    type="button"
                                    className="btn btn-light categories_cancel_button"
                                    style={{ width: "200px" }}
                                    onClick={()=>navigate("/winners/list")}
                                  >
                                    {" "}
                                    Cancel{" "}
                                  </button>
                                  <button
                                    type="submit"
                                    className="btn btn-danger"
                                    disabled={isLoading}
                                    style={{ width: "200px" }}
                                  >
                                    {isLoading === true?'Generating...':'Generate'}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      <Loading isLoading={isLoading} text="Fetching..." />
    </>
  );
}
